import { mapLocales } from "./locales";
const shortDateFormat = {
	day: "2-digit",
	month: "2-digit",
	year: "numeric",
	timeZone: "Europe/Berlin"
};
/**
* vue-i18n runtime configuration.
*
* This file is loaded via `vueI18n: 'config'` in nuxt.config.ts and passes
* options directly to the underlying vue-i18n instance.
*/
export default () => ({
	legacy: false,
	fallbackLocale: "de",
	allowComposition: true,
	globalInjection: true,
	flatJson: true,
	datetimeFormats: mapLocales(() => ({ short: shortDateFormat }))
});
